import { Container } from "@sainsburys-tech/luna-grid"
import useUser from "../hooks/useUser"
import { useMsal } from "@azure/msal-react"
import useRoles from "../hooks/useRoles"

const TestClaimsPage = () => {
  const { name, username, roles, inProgress } = useUser()
  const apiRoles = useRoles().apiRoles
  const { accounts } = useMsal()
  const claims = accounts[0]?.idTokenClaims

  return (
    <Container size="xs" className="ln-u-padding-top*4 ln-u-padding-bottom*4">
      <h3 id="s-page-title" className="s-page-title">
        Test Claims
      </h3>
      <div className="ms-4">
        <h4>Basic Info</h4>
        <pre>
          {JSON.stringify({ name, username, roles, inProgress }, null, 2)}
        </pre>
      </div>
      <div>
        <h4>Roles</h4>
        <pre>
            {JSON.stringify(apiRoles, null, 2)}
        </pre>
      </div> 
      <div>
        <h4>All Claims</h4>
        <pre>
          {JSON.stringify(claims, null, 2)}
        </pre>
      </div> 
    </Container>
  )
}

export default TestClaimsPage